<template>
  <Card
    class="library-card"
    @mouseover="handleCardOver"
    @mouseleave="handleCardLeave"
  >
    <div
      class="card-ad-container"
      v-bind:class="{ clickable: advertisement.link }"
      v-on="advertisement.link ? { click: goToAdLink } : {}"
    >
      <div
        class="card-ad-img"
        :style="{ 'background-image': `url('${advertisement.image_url}')` }"
      >
      </div>
      <div
        v-if="mouseOver && advertisement.link"
        class="card-ad-background"
      >
      </div>
    </div>
    <div class="card-cover-img-thumb clickable"></div>
    <div class="card-block clickable">
      <div class="row">
        <div class="col-12 card-info-section">
          <div class="card-body">
            <h4 class="card-title"></h4>
            <div class="card-subtitle typography--caption"></div>
          </div>
          <div class="divider"></div>
          <div class="card-bottom-desc">
            <div>
              <small class="typography--caption typography--color-secondary">
                <span style="color: transparent">&nbsp;</span>
              </small>
            </div>
            <div>
              <small class="typography--caption typography--color-secondary">&nbsp;</small>
            </div>
            <div v-if="showOwner">
              <small class="typography--caption typography--color-secondary">&nbsp;</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Card>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'ad-card',

    data() {
      return {
        mouseOver: false,
      };
    },

    props: [
      'showOwner',
    ],

    computed: {
      ...mapGetters([
        'advertisement',
      ]),
    },

    methods: {
      goToAdLink() {
        window.open(this.advertisement.link);
      },

      handleCardOver() {
        this.mouseOver = true;
      },

      handleCardLeave() {
        this.mouseOver = false;
      },
    },
  };
</script>

<style lang="scss">
  .card-ad-container {
    background-color: #fff;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 900;
    width: 100%;
    height: 100%;
  }

  .card-ad-background {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.30);
    top: 0;
    width: 100%;
    height: 100%;
  }

  .card-ad-img {
    width: 100%;
    height: 100%;
    border-radius: 3px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
</style>



// WEBPACK FOOTER //
// src/app/library/components/AdCard.vue